export enum ChartType {
  unknown = 0,
  pie = 1,
  pieAdvanced = 2,
  barVertical = 3,
  barHorizontal = 4,
  barVerticalGrouped = 5,
  barHorizontalGrouped = 6,
  line = 7,
  barVerticalStacked = 8,
  barHorizontalStacked = 9,
}
